import qs from 'qs';

// yet another url_helper. last one. I promise.
export function urlFor(path, q = {}) {
  const [beforeHash, hash] = String(path).split('#');
  const [base, existing] = beforeHash.split('?');
  const merged = { ...qs.parse(existing ?? ''), ...q };
  return `${base}${qs.stringify(merged, { addQueryPrefix: true })}${hash ? `#${hash}` : ''}`;
}

export function pathnameFromUrl(url) {
  if (!url) return '';
  try {
    if (/^https?:\/\//i.test(url)) return new URL(url).pathname;
  } catch {
    return '';
  }
  return url.split('?')[0].split('#')[0];
}

function isValidUrl(text) {
  try {
    // eslint-disable-next-line no-unused-vars
    const url = new URL(text);
  } catch (_) {
    return false;
  }
  return true;
}

const localePrefixRegex = /^\/?[a-z]{2}(-[a-z]{2})?\b/i;
export function stripLocalePrefix(path) {
  if (typeof path?.match === 'function' && path?.match(localePrefixRegex)) {
    return path.replace(localePrefixRegex, '');
  }
  return path;
}

export function PrefixWithLocale(url, locale) {
  // return if it's an absolute path (an absolute path shouldn't be localized)
  if (isValidUrl(url)) return url;

  let code;
  switch (typeof locale) {
    case 'string':
      code = locale.toLowerCase();
      break;
    case 'object':
      code = locale.code.toLowerCase();
      break;
    default:
      return url;
  }

  let path = stripLocalePrefix(url);
  if (path === '/') {
    path = '';
  }

  return `/${code}${path}`;
}
